(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/helpers/get-expanded-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/helpers/get-expanded-rows.js');
"use strict";

const getLogger = svs.core.log.getLogger;
const _svs$components$tipse = svs.components.tipsen.expandedSystems,
  expandErHexBoardToOutcomeIndexes = _svs$components$tipse.expandErHexBoardToOutcomeIndexes,
  expandErSROWHexBoardToOutcomeIndexes = _svs$components$tipse.expandErSROWHexBoardToOutcomeIndexes,
  expandOutcomesToSROW = _svs$components$tipse.expandOutcomesToSROW,
  expandScoreOutcomesRsysToSrows = _svs$components$tipse.expandScoreOutcomesRsysToSrows,
  expandSystemOutcomesToSROW = _svs$components$tipse.expandSystemOutcomesToSROW,
  expandERScoreboardToSrowHex = _svs$components$tipse.expandERScoreboardToSrowHex;
const wagerSystemTypes = svs.components.tipsen.engine.constants.wagerSystemTypes;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const logger = getLogger('tipsen:getExpandedRows');
const expandResultBoardsToSROW = _ref => {
  let boards = _ref.boards,
    shouldExpandERScoreBoardToSROWHex = _ref.shouldExpandERScoreBoardToSROWHex,
    eventTypeId = _ref.eventTypeId;
  if (shouldExpandERScoreBoardToSROWHex) {
    return expandERScoreboardToSrowHex(boards, eventTypeId);
  }
  logger.debug('Expanded board EventTypeId.RESULT to SROW', boards);
  const flatOutcomeRows = boards.map(row => expandErHexBoardToOutcomeIndexes(row, {
    eventTypeId
  }));
  return flatOutcomeRows.map(row => row.filter((_, index) => index % 2 === 0).map((outcome, index) => [parseInt(outcome[0], 10), parseInt(row[index * 2 + 1][0], 10)]));
};
const expandBoardsToSROW = function (board) {
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    systemType = _ref2.systemType,
    eventTypeId = _ref2.eventTypeId;
  if (systemType === wagerSystemTypes.MSYS) {
    logger.debug('Expanded board MSYS to SROW', board);
    return board.map(row => expandOutcomesToSROW(...expandErHexBoardToOutcomeIndexes(row, {
      eventTypeId
    }))).flat();
  }
  logger.debug("Expanded board ".concat(systemType, " to SROW"), board);
  return board.map(row => expandErSROWHexBoardToOutcomeIndexes(row));
};
const expandSignsToSROW = function (signs) {
  let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    systemType = _ref3.systemType,
    eventTypeId = _ref3.eventTypeId,
    mSigns = _ref3.mSigns,
    uSigns = _ref3.uSigns,
    systemNum = _ref3.systemNum,
    reduction = _ref3.reduction;
  switch (systemType) {
    case wagerSystemTypes.MSYS:
      logger.debug('Expanded MSYS to SROW', signs);
      return expandOutcomesToSROW(...signs);
    case wagerSystemTypes.USYS:
    case wagerSystemTypes.RSYS:
      if (eventTypeId === EventTypeId.RESULT) {
        logger.debug("Expanded ".concat(systemType, " of EventTypeId.RESULT to SROW with reductions ").concat(JSON.stringify(reduction)), signs);
        return expandScoreOutcomesRsysToSrows(signs, reduction);
      }
      logger.debug("Expanded signs ".concat(systemType, " to SROW"), signs);
      return expandSystemOutcomesToSROW(signs, mSigns, uSigns, systemNum);
    case wagerSystemTypes.SROW:
      logger.debug("Expanded signs ".concat(systemType, "} of type ").concat(eventTypeId, "} to SROW"), signs);
      return expandOutcomesToSROW(...signs);
    default:
      throw new Error("Unsupported system type ".concat(systemType));
  }
};
const getExpandedRows = function (_ref4, systemType, systemNum) {
  let boards = _ref4.boards,
    signs = _ref4.signs,
    mSigns = _ref4.mSigns,
    uSigns = _ref4.uSigns,
    reduction = _ref4.reduction;
  let _ref5 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref5$eventTypeId = _ref5.eventTypeId,
    eventTypeId = _ref5$eventTypeId === void 0 ? EventTypeId.EVENT_1X2 : _ref5$eventTypeId,
    _ref5$shouldExpandERS = _ref5.shouldExpandERScoreBoardToSROWHex,
    shouldExpandERScoreBoardToSROWHex = _ref5$shouldExpandERS === void 0 ? false : _ref5$shouldExpandERS;
  if (boards) {
    if (eventTypeId === EventTypeId.RESULT) {
      return expandResultBoardsToSROW({
        boards,
        shouldExpandERScoreBoardToSROWHex,
        eventTypeId
      });
    }
    return expandBoardsToSROW(boards, {
      systemType,
      eventTypeId
    });
  }
  return expandSignsToSROW(signs, {
    systemType,
    eventTypeId,
    mSigns,
    uSigns,
    systemNum,
    reduction
  });
};
setGlobal('svs.components.tipsen.store.helpers.getExpandedRows', getExpandedRows);

 })(window);